import {
  calculateRiskByDayUseCase,
  calculateRiskBySedeUseCase,
  calculateRiskIndicatorsUseCase,
} from '@/di/home.container';
import { useHomeStore } from '@/shared/stores';

/**
 * Hook Facade para interactuar con el store del home.
 * Este es el ÚNICO lugar que debe importar y usar 'useHomeStore' directamente.
 * Proporciona una API estable y segura para el resto de la aplicación
 *
 * Cumple ISP: Interfaces segregadas y específicas para cada necesidad
 */
export const useAppHome = () => {
  // 1. Selección de las piezas del store
  const metricsBySede = useHomeStore((state) => state.metricsBySede);
  const metricsSummary = useHomeStore((state) => state.metricsSummary);
  const activeFilter = useHomeStore((state) => state.activeFilter);
  const searchQuery = useHomeStore((state) => state.searchQuery);
  const isLoading = useHomeStore((state) => state.isLoading);
  const activeJornada = useHomeStore((state) => state.activeJornada);
  const activeSede = useHomeStore((state) => state.activeSede);

  // 2. Selección de las acciones del store
  const loadHome = useHomeStore((state) => state.loadHome);
  const setFilter = useHomeStore((state) => state.setFilter);
  const setSearchQuery = useHomeStore((state) => state.setSearchQuery);
  const setLoading = useHomeStore((state) => state.setLoading);
  const clearHome = useHomeStore((state) => state.clearHome);
  const setActiveJornada = useHomeStore((state) => state.setActiveJornada);
  const setActiveSede = useHomeStore((state) => state.setActiveSede);

  // 3. Use cases para cálculos de riesgo
  const calculateRiskBySede = calculateRiskBySedeUseCase();
  const calculateRiskIndicators = calculateRiskIndicatorsUseCase();
  const calculateRiskByDay = calculateRiskByDayUseCase();

  // 4. Devuelve una API pública y limpia para que la usen los componentes
  return {
    // valores del estado
    metricsBySede,
    metricsSummary,
    activeFilter,
    searchQuery,
    isLoading,
    activeJornada,
    activeSede,

    // acciones para modificar el estado (directas, sin wrappers innecesarios)
    loadHome,
    setFilter,
    setSearchQuery,
    setLoading,
    clearHome,
    setActiveJornada,
    setActiveSede,

    // use cases para cálculos
    calculateRiskBySede,
    calculateRiskIndicators,
    calculateRiskByDay,
  };
};
